module.exports = __webpack_public_path__ + "img/resend-verification-code.0ada7c03.svg";